export default __webpack_public_path__ + "static/wav-top-9b84ca20241b9ef481d66af0545cd7c2.png";